import React, { Component } from "react";

import Video from "../../Components/Video";

class Einde extends Component {
  render() {
    return (
      <div className="wat-kunnen-wij-doen">
        <Video video={"https://www.youtube.com/embed/gikyr2BvXd0"} />
      </div>
    );
  }
}

export default Einde;
